import {connect} from 'react-redux';
import Controls from '../../components/search/controls';
import { loadLocations } from '../../actions/';

const mapStateToProps = (state) => {
  return {
    sourceLocations: state.store.locations,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadLocations: (regionUrlParts) => dispatch(loadLocations(regionUrlParts)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Controls);



// WEBPACK FOOTER //
// ./src/containers/searchpage/controls.js